import { render, staticRenderFns } from "./WithdrawalPasswordGate.vue?vue&type=template&id=f8e84fbe"
import script from "./WithdrawalPasswordGate.vue?vue&type=script&lang=js"
export * from "./WithdrawalPasswordGate.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalPasswordGate.vue?vue&type=style&index=0&id=f8e84fbe&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports